import script from "./RecoveryGoalTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryGoalTypes.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryGoalTypes.vue?vue&type=style&index=0&id=6cba6055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cba6055"]])

export default __exports__